<template>
  <history-template>
    <template #histories>
      <template v-for="history in histories">
        <hc-comment
          v-if="history.type === HISTORY.TYPE.COMMENT"
          :key="history.id"
          :vbComment="history.comment"
        />

        <hc-common-create-action-log
          v-else-if="history.actionName === ACTION_LOG_ACTION_NAME.TAO_MOI"
          :key="history.id"
          :actionLog="history.actionLog"
        />

        <hc-quy-che-quy-dinh-common-update-action-log
          v-else-if="history.actionName === ACTION_LOG_ACTION_NAME.CAP_NHAT"
          :key="history.id"
          :actionLog="history.actionLog"
          :hcCaseCommandsId="hcCaseCommandsId"
        />

        <hc-quy-che-quy-dinh-bao-cao-action-log
          v-else-if="
            history.actionName === ACTION_LOG_ACTION_NAME.BAO_CAO_TIEN_DO ||
              history.actionName ===
                ACTION_LOG_ACTION_NAME.BAO_CAO_HOAN_THANH ||
              history.actionName === ACTION_LOG_ACTION_NAME.BAO_TRUNG_CHI_DAO
          "
          :key="history.id"
          :actionLog="history.actionLog"
        />

        <hc-ycbs-action-log
          v-else-if="
            history.actionName === ACTION_LOG_ACTION_NAME.YEU_CAU_BO_SUNG
          "
          :key="history.id"
          :actionLog="history.actionLog"
        />

        <hc-gia-han-action-log
          v-else-if="history.actionName === ACTION_LOG_ACTION_NAME.GIA_HAN"
          :key="history.id"
          :actionLog="history.actionLog"
        />

        <hc-gia-han-action-log
          v-else-if="history.actionName === ACTION_LOG_ACTION_NAME.PHE_DUYET_GIA_HAN"
          :key="history.id"
          :actionLog="history.actionLog"
        />

        <hc-dk-deadline-action-log
          v-else-if="
            history.actionName === ACTION_LOG_ACTION_NAME.DANG_KY_DEADLINE
          "
          :key="history.id"
          :actionLog="history.actionLog"
        />

        <hc-huy-action-log
          v-else-if="history.actionName === ACTION_LOG_ACTION_NAME.HUY_YEU_CAU"
          :key="history.id"
          :actionLog="history.actionLog"
        />

        <hc-phe-duyet-action-log
          v-else-if="history.actionName === ACTION_LOG_ACTION_NAME.PHE_DUYET"
          :key="history.id"
          :actionLog="history.actionLog"
        />

        <hc-cho-y-kien-action-log
          v-else-if="history.actionName === ACTION_LOG_ACTION_NAME.CHO_Y_KIEN"
          :key="history.id"
          :actionLog="history.actionLog"
        />
      </template>
    </template>

    <template #footer>
      <hc-comment-input
        :hcCaseCommandsId="hcCaseCommandsId"
        :hcType="hcType"
        @commentSuccess="commentSuccess"
      />
    </template>
  </history-template>
</template>

<script>
import vbCommentService from "../../../services/vbCommentService";
import handleRequestErrorMixin from "../../handleRequestErrorMixin";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import HcComment from "../ketluan/hc-command-comment";
import HcCommentInput from "../ketluan/hc-command-comment-input";
import HistoryTemplate from "../ketluan/history-template";
import actionLogService from "../../../services/actionLogService";
import h from "../../../services/h";
import HcCommonCreateActionLog from "../ketluan/hc-commands-common-create-action-log";
import constants from "../../../constants";
import HcQuyCheQuyDinhCommonUpdateActionLog from "./hc-quychequydinh-common-update-action-log.vue";
import HcQuyCheQuyDinhBaoCaoActionLog from "./hc-quychequydinh-bao-cao-action-log";
import HcYcbsActionLog from "../ketluan/hc-commands-ycbs-action-log";
import HcGiaHanActionLog from "../ketluan/hc-commands-gia-han-action-log";
import HcDkDeadlineActionLog from "../ketluan/hc-commands-dk-deadline-action-log";
import HcHuyActionLog from "../ketluan/hc-commands-huy-action-log";
import HcPheDuyetActionLog from "../ketluan/hc-commands-phe-duyet-action-log";
import HcChoYKienActionLog from "../ketluan/hc-commands-cho-y-kien-action-log";

export default {
  name: "hc-quychequydinh-history",
  mixins: [handleRequestErrorMixin],
  props: ["hcCaseCommandsId", "hcCaseCommandsCommonId","hcType"],
  components: {
    HcComment,
    HcCommentInput,
    HcChoYKienActionLog,
    HcPheDuyetActionLog,
    HcHuyActionLog,
    HcDkDeadlineActionLog,
    HcGiaHanActionLog,
    HcYcbsActionLog,
    HcQuyCheQuyDinhBaoCaoActionLog,
    HcQuyCheQuyDinhCommonUpdateActionLog,
    HcCommonCreateActionLog,
    HistoryTemplate,
    VuePerfectScrollbar
  },
  filters: {},

  data() {
    return {
      isFullScreen: true,
      actionLogs: null,
      histories: [],
      comments: [],
      ACTION_LOG_ACTION_NAME: constants.ACTION_LOG_ACTION_NAME.CHI_DAO,
      HISTORY: constants.HISTORY
    };
  },

  watch: {},
  computed: {},

  created() {
    this.reloadHistories();
  },

  methods: {
    commentSuccess({ vbComment }) {
      this.comments.push(vbComment);
      this.populateHistories();
    },

    async reloadHistories() {
      await this.loadActionLogs();
      await this.loadComments();
      this.populateHistories();
    },

    loadActionLogs() {
      return actionLogService
        .findAllForHcCaseCommands(
          this.hcCaseCommandsId,
          this.hcCaseCommandsCommonId
        )
        .then(response => (this.actionLogs = response.data));
    },

    loadComments() {
      return vbCommentService
        .findAllHcCommandComments(
          { objectId: this.hcCaseCommandsId },
          { sort: "createTime,desc" }
        )
        .then(response => {
          this.comments = response.data;
        });
    },

    populateHistories() {
      let histories = [];

      h.each(this.actionLogs, actionLog => {
        histories.push({
          id: actionLog.id,
          type: constants.HISTORY.TYPE.ACTION_LOG,
          createTime: actionLog.createTime,
          actionName: actionLog.actionName,
          actionLog: actionLog
        });
      });

      h.each(this.comments, comment => {
        histories.push({
          id: comment.id,
          type: constants.HISTORY.TYPE.COMMENT,
          createTime: comment.createTime,
          comment: comment
        });
      });

      //sap xep lại theo thời gian
      histories.sort((node1, node2) => node2.createTime - node1.createTime);

      this.histories = histories;
    }
  }
};
</script>

<style scoped>
.full-screen {
  animation: half-to-full 0.5s;
  transition: 0.5s;
  width: 100%;
}

.half-screen {
  width: 75%;
  max-width: 420px;
  transition: 0.5s;
}

@keyframes half-to-full {
  from {
    width: 75%;
  }
  to {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/adminstration/quychequydinh/hc-quychequydinh-history.vue